<template>
  <div
    class="scroll-spy__item"
  >
    <Headline
      v-if="resource.columns.title"
      :size="1"
      :level="2"
    >
      {{ resource.columns.title }}
    </Headline>
    <div
      v-for="child in children"
      :key="child.id"
    >
      <div
        v-if="child.resource_class_name === 'TitledMarkdown'"
        class="scroll-spy__markdown"
      >
        <Wysiwyg>
          <div v-html="child.columns.text" />
        </Wysiwyg>
      </div>
      <div
        v-else-if="child.resource_class_name === 'Media'"
        class="scroll-spy__media"
      >
        <Media :path="child.columns.path" />
      </div>
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import Wysiwyg from 'beisheim/components/elements/wysiwyg'
import Headline from 'beisheim/components/elements/headline'
import Media from 'beisheim/components/elements/media'
import editable from '@i22/frontend-cms-utils/mixins/editable'

export default {
  components: {
    Wysiwyg,
    Headline,
    Media
  },
  mixins: [editable],
  computed: {
    children () {
      return sortBy(this.resource.children, 'sort_key')
    }
  }
}
</script>
